import { FormActions } from '~/components/ui/card/FormActions';

interface FilterActionsProps {
  onClear: () => void;
  onApply: () => void;
  clearTestId?: string;
  applyTestId?: string;
}

/** The filter tray's footer (DESIGN.md §10.2): Clear all / Apply filters, never "Save". */
export function FilterActions({ onClear, onApply, clearTestId, applyTestId }: FilterActionsProps) {
  return (
    <FormActions
      discardLabel="Clear all"
      onDiscard={onClear}
      saveLabel="Apply filters"
      onSave={onApply}
      discardTestId={clearTestId}
      saveTestId={applyTestId}
    />
  );
}
